import { render, staticRenderFns } from "./FormularyReview.html?vue&type=template&id=a4580ba2&external"
import script from "./FormularyReview.js?vue&type=script&lang=js&external"
export * from "./FormularyReview.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports